import { render } from "./autocompleteStudents.vue?vue&type=template&id=7c2bae74"
import script from "./autocompleteStudents.vue?vue&type=script&lang=js"
export * from "./autocompleteStudents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__